import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlservico = '/service/portal/conteudo/transparencia/'

class InformacoesInstitucionaisService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        const categoria = config.categoria ? config.categoria : null
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        this.state = {
            paramCategoria: categoria ? `?categoria=${categoria}` : '',
        }
    }
    getInformacoes() {
        return this.conex.get(urlservico + 'parametros' + this.state.paramCategoria)
    }
}

export default InformacoesInstitucionaisService
